import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import "moment/locale/de";

import EditableTable from "../components/Table/EditableTable";
import { OrderContext, UserContext } from "../context";
import firebase from "../services/firebase";
import { isDev, getPartnerName } from "../helpers";

moment.locale("de");

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const historyCard = ({
  classes,
  updatedAt,
  order,
  handleSameAgain,
  contactInfo,
}) => (
  <Card className={classes.root}>
    <CardContent>
      <Typography className={classes.title} color="textSecondary" gutterBottom>
        {moment(updatedAt).format("MMMM Do YYYY")}
      </Typography>

      <Typography className={classes.pos} color="textSecondary">
        {moment(updatedAt).fromNow()}
      </Typography>
      <EditableTable
        hiddenAction
        orders={order}
        deliverCost={
          contactInfo.method === "Lieferung" && !contactInfo.isFreeDistance
            ? 5
            : 0
        }
      />
    </CardContent>
    <CardActions>
      <Button
        size="small"
        variant="contained"
        color="secondary"
        onClick={() => handleSameAgain(order)}
      >
        Nachbestellen
      </Button>
    </CardActions>
  </Card>
);

export default (props) => {
  const classes = useStyles();
  const [orderHistory, setOrderHistory] = React.useState([]);
  const { orders, setOrders } = React.useContext(OrderContext);
  const { user } = React.useContext(UserContext);
  const history = useHistory();

  React.useEffect(() => {
    if (!user.uid) return;
    const unsubscribe = firebase
      .firestore()
      .collection(isDev ? "devOrders" : "orders")
      .where("partnerName", "==", getPartnerName().toLowerCase())
      .where("uid", "==", user.uid)
      .onSnapshot((snapshot) => {
        if (isDev && snapshot.docs.length > 0)
          console.log(user.uid, snapshot.docs[0].data());
        const sortedHistoryDocs = snapshot.docs.sort((docA, docB) =>
          docA.data().updatedAt > docB.data().updatedAt ? -1 : 1
        );
        setOrderHistory(sortedHistoryDocs);
      });
    return () => unsubscribe();
  }, [user.uid]);

  const handleSameAgain = (order) => {
    setOrders([...orders, ...order]);
    history.push("/checkout");
  };
  if (isDev) console.log(orderHistory);
  return (
    <Grid container spacing={3}>
      {orderHistory.map((each) => (
        <Grid item key={each.id}>
          {historyCard({
            classes,
            ...each.data(),
            updatedAt: each.data().updatedAt.toDate(),

            handleSameAgain,
          })}
        </Grid>
      ))}
    </Grid>
  );
};
